import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import { LEGAL } from "@/lib/legal";

/**
 * Shared chrome for the policy pages.
 *
 * These pages have to stay readable when they are opened straight from the Play
 * listing by someone who has never installed the app, so the layout is plain
 * prose with no data fetching and nothing that depends on being signed in.
 */
export const LegalLayout = ({ title, subtitle, children }) => (
  <div className="min-h-screen pt-24 pb-20 px-4" data-testid="legal-page">
    <motion.article
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-3xl mx-auto"
    >
      <h1 className="font-heading text-3xl md:text-4xl font-black mb-2">{title}</h1>
      {subtitle && <p className="text-sm text-white/50 mb-2">{subtitle}</p>}
      <p className="text-xs text-white/30 mb-10">
        Effective {LEGAL.effectiveDate} &middot; Last updated {LEGAL.lastUpdated}
      </p>

      <div className="space-y-6 text-white/70 text-[15px] leading-relaxed">
        {children}
      </div>

      <nav className="mt-14 pt-6 border-t border-white/10 flex flex-wrap gap-x-6 gap-y-2 text-sm text-white/40">
        <NavLink to="/privacy" className="hover:text-orange-400 transition-colors">
          Privacy Policy
        </NavLink>
        <NavLink to="/terms" className="hover:text-orange-400 transition-colors">
          Terms of Service
        </NavLink>
        <NavLink to="/delete-account" className="hover:text-orange-400 transition-colors">
          Delete my account
        </NavLink>
        <a href={`mailto:${LEGAL.supportEmail}`} className="hover:text-orange-400 transition-colors">
          Contact support
        </a>
      </nav>
    </motion.article>
  </div>
);

export const Section = ({ heading, children }) => (
  <section className="space-y-3">
    <h2 className="font-heading text-lg font-bold text-white">{heading}</h2>
    {children}
  </section>
);

export const Bullets = ({ items }) => (
  <ul className="list-disc pl-5 space-y-2 marker:text-orange-500/70">
    {items.map((item, i) => (
      <li key={i}>{item}</li>
    ))}
  </ul>
);
